import { useMemo as l, useCallback as o } from "react";
import { isClient as I } from "./index41.mjs";
const v = (r, u = {}) => {
  const { parser: n = JSON.parse, stringifier: s = JSON.stringify, useSessionStorage: i } = u, t = l(() => {
    if (I())
      return i ? window.sessionStorage : window.localStorage;
  }, [i]), f = o(
    (e) => {
      r && t && t.setItem(r, s(e));
    },
    [r, t, s]
  ), a = o(() => {
    if (!r || !t) return;
    const e = t.getItem(r);
    return e ? n(e) : null;
  }, [r, t, n]), c = o(() => {
    r && t && t.removeItem(r);
  }, [r, t]), g = o(
    (e) => {
      t && Object.keys(t).forEach((m) => {
        m.startsWith(e) && t.removeItem(m);
      });
    },
    [t]
  );
  return { setItem: f, getItem: a, removeItem: c, removeByPrefix: g };
};
export {
  v as useStorage
};
